import React from "react";
import { useInView } from "react-intersection-observer";
import { LoadingPattern } from "@/components/ui/pattern-viewer";

interface LazySectionProps {
  children: React.ReactNode | ((props: { inView: boolean }) => React.ReactNode);
  minHeight?: number;
  className?: string;
}

export function LazySection({ children, minHeight = 200, className = "" }: LazySectionProps) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const isRenderProp = typeof children === 'function';
  return (
    <div ref={ref} style={{ minHeight }} className={className}>
      {isRenderProp
        ? (children as (props: { inView: boolean }) => React.ReactNode)({ inView })
        : inView
          ? children
          : <div style={{ minHeight }}><LoadingPattern patternName="cell-pattern" size="md" /></div>
      }
    </div>
  );
} 